<template>
  <div class="header-nav-wrapper">
    <svg style="display: none">
      <defs>
        <filter id="liquid_glass_filter" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
          <feDisplacementMap :scale="glassParams.displacementScale" />
        </filter>
      </defs>
    </svg>

    <div class="nav-row">
      <div class="liquid_glass-wrapper nav-main" style="--border-radius: 26px">
        <div class="liquid_glass-outer" :style="outerLayerStyle" />
        <div class="liquid_glass-cover" :style="coverLayerStyle" />
        <div class="liquid_glass-sharp" :style="sharpLayerStyle" />
        <div class="liquid_glass-reflect" :style="reflectLayerStyle" />

        <div class="nav-content">
          <div class="title-block">
            <p class="title">桂 枝 岭 水 厂</p>
            <p class="sub-title">{{ currentTime }}</p>
          </div>

          <div class="weather">
            <a-icon type="cloud" />
            <span>晴 18℃</span>
          </div>

          <div class="actions">
            <a-tooltip title="首页">
              <a-icon type="home" class="action-icon" @click="goHome" />
            </a-tooltip>
            <a-tooltip title="后台管理">
              <a-icon type="desktop" class="action-icon" @click="goBackstage" />
            </a-tooltip>
            <a-tooltip title="设置">
              <a-icon type="setting" class="action-icon" @click="showPanel = true" />
            </a-tooltip>
            <a-tooltip title="全屏">
              <a-icon
                :type="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"
                class="action-icon"
                @click="toggleFullscreen"
              />
            </a-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="liquid_glass-wrapper feature-card" :style="featureCardStyle" @mousedown="startDrag">
        <div class="liquid_glass-outer" :style="outerLayerStyle" />
        <div class="liquid_glass-cover" :style="coverLayerStyle" />
        <div class="liquid_glass-sharp" :style="sharpLayerStyle" />
        <div class="liquid_glass-reflect" :style="reflectLayerStyle" />
        <div
          v-for="handle in resizeHandles"
          v-show="showResizeHandles"
          :key="handle"
          :class="['resize-handle', `resize-handle-${handle}`]"
          @mousedown.stop.prevent="startResize($event, handle)"
        />
      </div>
    </div>

    <a-drawer
      title="HeaderNav 控制面板"
      :visible="showPanel"
      :width="360"
      :mask="false"
      :maskClosable="true"
      :destroyOnClose="false"
      wrapClassName="header-nav-drawer"
      placement="right"
      @close="showPanel = false"
    >
      <div class="control-panel">
        <div class="control-item">
          <div class="control-label">折射与滤镜</div>
          <div class="control-row">
            <span class="control-key">折射强度</span>
            <a-slider
              v-model="glassParams.displacementScale"
              :min="0"
              :max="320"
              :step="1"
              @change="sanitizeGlassParams"
            />
            <a-input-number
              v-model="glassParams.displacementScale"
              :min="0"
              :max="320"
              :step="1"
              size="small"
              @change="sanitizeGlassParams"
            />
          </div>
          <div class="control-row">
            <span class="control-key">模糊</span>
            <a-slider v-model="glassParams.blurPx" :min="0" :max="18" :step="0.5" @change="sanitizeGlassParams" />
            <a-input-number
              v-model="glassParams.blurPx"
              :min="0"
              :max="18"
              :step="0.5"
              size="small"
              @change="sanitizeGlassParams"
            />
          </div>
          <div class="control-row">
            <span class="control-key">饱和度</span>
            <a-slider v-model="glassParams.saturation" :min="80" :max="220" :step="1" @change="sanitizeGlassParams" />
            <a-input-number
              v-model="glassParams.saturation"
              :min="80"
              :max="220"
              :step="1"
              size="small"
              @change="sanitizeGlassParams"
            />
          </div>
          <div class="control-row">
            <span class="control-key">遮罩透明</span>
            <a-slider
              v-model="glassParams.coverOpacity"
              :min="0"
              :max="0.5"
              :step="0.01"
              @change="sanitizeGlassParams"
            />
            <a-input-number
              v-model="glassParams.coverOpacity"
              :min="0"
              :max="0.5"
              :step="0.01"
              size="small"
              @change="sanitizeGlassParams"
            />
          </div>
          <div class="control-row">
            <span class="control-key">遮罩颜色</span>
            <input v-model="glassParams.coverColor" class="color-picker" type="color" @input="sanitizeGlassParams" />
            <span class="color-value">{{ glassParams.coverColor }}</span>
          </div>
          <div class="control-row">
            <span class="control-key">边缘高光</span>
            <a-slider v-model="glassParams.edgeLight" :min="0" :max="1" :step="0.01" @change="sanitizeGlassParams" />
            <a-input-number
              v-model="glassParams.edgeLight"
              :min="0"
              :max="1"
              :step="0.01"
              size="small"
              @change="sanitizeGlassParams"
            />
          </div>
          <div class="control-row">
            <span class="control-key">内部反射</span>
            <a-slider v-model="glassParams.reflectLight" :min="0" :max="1" :step="0.01" @change="sanitizeGlassParams" />
            <a-input-number
              v-model="glassParams.reflectLight"
              :min="0"
              :max="1"
              :step="0.01"
              size="small"
              @change="sanitizeGlassParams"
            />
          </div>
        </div>

        <div class="control-item">
          <div class="control-actions">
            <a-button size="small" @click="resetGlassParams">重置材质</a-button>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

export default {
  name: 'HeaderNav',
  data() {
    return {
      currentTime: '',
      timer: null,
      isFullscreen: false,
      showPanel: false,
      cardRect: {
        x: 0,
        y: 0,
        width: 820,
        height: 260
      },
      minCardWidth: 260,
      minCardHeight: 160,
      maxCardWidth: 1800,
      maxCardHeight: 900,
      cardRadius: 24,
      showResizeHandles: true,
      glassParams: {
        displacementScale: 200,
        blurPx: 2,
        saturation: 120,
        coverOpacity: 0.12,
        coverColor: '#000000',
        edgeLight: 0.6,
        reflectLight: 0.2
      },
      interaction: null,
      resizeHandles: ['n', 'e', 's', 'w', 'ne', 'nw', 'se', 'sw']
    }
  },
  computed: {
    featureCardStyle() {
      return {
        width: `${this.cardRect.width}px`,
        height: `${this.cardRect.height}px`,
        transform: `translate(${this.cardRect.x}px, ${this.cardRect.y}px)`,
        '--border-radius': `${this.cardRadius}px`
      }
    },
    outerLayerStyle() {
      return {
        backdropFilter: `url(#liquid_glass_filter) saturate(${this.glassParams.saturation}%)`,
        WebkitBackdropFilter: `url(#liquid_glass_filter) saturate(${this.glassParams.saturation}%)`
      }
    },
    coverLayerStyle() {
      const maskRgb = this.hexToRgb(this.glassParams.coverColor)
      return {
        backdropFilter: `blur(${this.glassParams.blurPx}px)`,
        WebkitBackdropFilter: `blur(${this.glassParams.blurPx}px)`,
        background: `rgba(${maskRgb.r}, ${maskRgb.g}, ${maskRgb.b}, ${this.glassParams.coverOpacity})`
      }
    },
    sharpLayerStyle() {
      const strong = (this.glassParams.edgeLight * 0.8).toFixed(3)
      const weak = (this.glassParams.edgeLight * 0.95).toFixed(3)
      return {
        boxShadow: `inset 1px 1px 0 0 rgba(255, 255, 255, ${strong}), inset -1px -1px 0 0 rgba(255, 255, 255, ${weak})`
      }
    },
    reflectLayerStyle() {
      const reflect = this.glassParams.reflectLight.toFixed(3)
      const reflectWeak = (this.glassParams.reflectLight * 0.9).toFixed(3)
      return {
        boxShadow: `inset 2px 2px 6px 2px rgba(255, 255, 255, ${reflect}), inset -2px -2px 4px -1px rgba(255, 255, 255, ${reflectWeak})`
      }
    }
  },
  created() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.removeInteractionListeners()
  },
  methods: {
    updateTime() {
      this.currentTime = moment().format('YYYY年MM月DD日 dddd HH:mm:ss')
    },
    goHome() {
      this.$router.push('/')
    },
    goBackstage() {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}智慧水厂系统`)
      this.$router.push('/water-works/workbench/dataMonitoring')
    },
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
        this.isFullscreen = true
      } else if (document.exitFullscreen) {
        document.exitFullscreen()
        this.isFullscreen = false
      }
    },
    startDrag(event) {
      if (event.button !== 0 || event.target.classList.contains('resize-handle')) return
      this.interaction = {
        mode: 'drag',
        startMouseX: event.clientX,
        startMouseY: event.clientY,
        startX: this.cardRect.x,
        startY: this.cardRect.y
      }
      this.addInteractionListeners()
    },
    startResize(event, dir) {
      if (event.button !== 0) return
      this.interaction = {
        mode: 'resize',
        dir,
        startMouseX: event.clientX,
        startMouseY: event.clientY,
        startX: this.cardRect.x,
        startY: this.cardRect.y,
        startWidth: this.cardRect.width,
        startHeight: this.cardRect.height
      }
      this.addInteractionListeners()
    },
    addInteractionListeners() {
      window.addEventListener('mousemove', this.handleInteractionMove)
      window.addEventListener('mouseup', this.stopInteraction)
    },
    removeInteractionListeners() {
      window.removeEventListener('mousemove', this.handleInteractionMove)
      window.removeEventListener('mouseup', this.stopInteraction)
    },
    handleInteractionMove(event) {
      if (!this.interaction) return
      const dx = event.clientX - this.interaction.startMouseX
      const dy = event.clientY - this.interaction.startMouseY
      if (this.interaction.mode === 'drag') {
        this.cardRect.x = this.interaction.startX + dx
        this.cardRect.y = this.interaction.startY + dy
        this.sanitizeCardRect()
        return
      }
      const dir = this.interaction.dir
      let nextX = this.interaction.startX
      let nextY = this.interaction.startY
      let nextWidth = this.interaction.startWidth
      let nextHeight = this.interaction.startHeight
      if (dir.includes('e')) {
        nextWidth = this.interaction.startWidth + dx
      }
      if (dir.includes('s')) {
        nextHeight = this.interaction.startHeight + dy
      }
      if (dir.includes('w')) {
        nextWidth = this.interaction.startWidth - dx
        nextX = this.interaction.startX + dx
      }
      if (dir.includes('n')) {
        nextHeight = this.interaction.startHeight - dy
        nextY = this.interaction.startY + dy
      }
      if (nextWidth < this.minCardWidth) {
        if (dir.includes('w')) {
          nextX -= this.minCardWidth - nextWidth
        }
        nextWidth = this.minCardWidth
      }
      if (nextHeight < this.minCardHeight) {
        if (dir.includes('n')) {
          nextY -= this.minCardHeight - nextHeight
        }
        nextHeight = this.minCardHeight
      }
      this.cardRect.x = nextX
      this.cardRect.y = nextY
      this.cardRect.width = nextWidth
      this.cardRect.height = nextHeight
      this.sanitizeCardRect()
    },
    stopInteraction() {
      this.interaction = null
      this.removeInteractionListeners()
    },
    clampNumber(value, min, max) {
      if (Number.isNaN(Number(value))) return min
      return Math.min(max, Math.max(min, Number(value)))
    },
    hexToRgb(hex) {
      const normalized = (hex || '').replace('#', '')
      if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
        return { r: 0, g: 0, b: 0 }
      }
      return {
        r: parseInt(normalized.slice(0, 2), 16),
        g: parseInt(normalized.slice(2, 4), 16),
        b: parseInt(normalized.slice(4, 6), 16)
      }
    },
    sanitizeCardRect() {
      this.cardRect.x = this.clampNumber(this.cardRect.x, -900, 900)
      this.cardRect.y = this.clampNumber(this.cardRect.y, -300, 900)
      this.cardRect.width = this.clampNumber(this.cardRect.width, this.minCardWidth, this.maxCardWidth)
      this.cardRect.height = this.clampNumber(this.cardRect.height, this.minCardHeight, this.maxCardHeight)
      this.cardRadius = this.clampNumber(this.cardRadius, 0, 60)
    },
    sanitizeGlassParams() {
      this.glassParams.displacementScale = this.clampNumber(this.glassParams.displacementScale, 0, 320)
      this.glassParams.blurPx = this.clampNumber(this.glassParams.blurPx, 0, 18)
      this.glassParams.saturation = this.clampNumber(this.glassParams.saturation, 80, 220)
      this.glassParams.coverOpacity = this.clampNumber(this.glassParams.coverOpacity, 0, 0.5)
      if (!/^#[0-9a-fA-F]{6}$/.test(this.glassParams.coverColor)) {
        this.glassParams.coverColor = '#000000'
      }
      this.glassParams.edgeLight = this.clampNumber(this.glassParams.edgeLight, 0, 1)
      this.glassParams.reflectLight = this.clampNumber(this.glassParams.reflectLight, 0, 1)
    },
    resetGlassParams() {
      this.glassParams = {
        displacementScale: 200,
        blurPx: 2,
        saturation: 120,
        coverOpacity: 0.12,
        coverColor: '#000000',
        edgeLight: 0.6,
        reflectLight: 0.2
      }
    },
    resetFeatureCard() {
      this.cardRect = {
        x: 0,
        y: 0,
        width: 820,
        height: 260
      }
      this.cardRadius = 24
      this.showResizeHandles = true
    },
    centerFeatureCard() {
      this.cardRect.x = 0
      this.cardRect.y = 0
      this.sanitizeCardRect()
    }
  }
}
</script>

<style lang="less" scoped>
.header-nav-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 0 0;
}

.nav-row {
  width: 1890px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-row {
  position: relative;
  width: 1890px;
  display: flex;
  justify-content: center;
  margin-top: 14px;
  min-height: 360px;
}

.liquid_glass-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: var(--border-radius);
}

.nav-main {
  height: 64px;
  width: 100%;
}

.feature-card {
  cursor: move;
  user-select: none;
}

.resize-handle {
  position: absolute;
  z-index: 8;
  pointer-events: auto;
}

.resize-handle-n,
.resize-handle-s {
  left: 20px;
  right: 20px;
  height: 10px;
}

.resize-handle-n {
  top: -5px;
  cursor: ns-resize;
}

.resize-handle-s {
  bottom: -5px;
  cursor: ns-resize;
}

.resize-handle-e,
.resize-handle-w {
  top: 20px;
  bottom: 20px;
  width: 10px;
}

.resize-handle-e {
  right: -5px;
  cursor: ew-resize;
}

.resize-handle-w {
  left: -5px;
  cursor: ew-resize;
}

.resize-handle-ne,
.resize-handle-nw,
.resize-handle-se,
.resize-handle-sw {
  width: 14px;
  height: 14px;
}

.resize-handle-ne {
  top: -7px;
  right: -7px;
  cursor: nesw-resize;
}

.resize-handle-nw {
  top: -7px;
  left: -7px;
  cursor: nwse-resize;
}

.resize-handle-se {
  right: -7px;
  bottom: -7px;
  cursor: nwse-resize;
}

.resize-handle-sw {
  left: -7px;
  bottom: -7px;
  cursor: nesw-resize;
}

.liquid_glass-outer {
  backdrop-filter: url(#liquid_glass_filter);
  -webkit-backdrop-filter: url(#liquid_glass_filter);
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: var(--border-radius);
  mask-image: url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%25%22%20height%3D%22100%25%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20rx%3D%220%22%20ry%3D%220%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E'),
    url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%25%22%20height%3D%22100%25%22%3E%3Crect%20x%3D%225%22%20y%3D%225%22%20width%3D%22calc(100%25%20-%2010px)%22%20height%3D%22calc(100%25%20-%2010px)%22%20rx%3D%2221%22%20ry%3D%2221%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E');
  -webkit-mask-image: url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%25%22%20height%3D%22100%25%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20rx%3D%220%22%20ry%3D%220%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E'),
    url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%25%22%20height%3D%22100%25%22%3E%3Crect%20x%3D%225%22%20y%3D%225%22%20width%3D%22calc(100%25%20-%2010px)%22%20height%3D%22calc(100%25%20-%2010px)%22%20rx%3D%2221%22%20ry%3D%2221%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E');
  mask-composite: exclude;
  -webkit-mask-composite: xor;
}

.liquid_glass-cover {
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: var(--border-radius);
  background: rgba(0, 0, 0, 0.12);
}

.liquid_glass-sharp {
  position: absolute;
  inset: 0;
  z-index: 3;
  box-shadow: inset 1px 1px 0 0 rgba(255, 255, 255, 0.5), inset -1px -1px 0 0 rgba(255, 255, 255, 0.6);
  border-radius: var(--border-radius);
}

.liquid_glass-reflect {
  position: absolute;
  inset: 1px;
  z-index: 2;
  box-shadow: inset 2px 2px 6px 2px rgba(255, 255, 255, 0.2), inset -2px -2px 4px -1px rgba(255, 255, 255, 0.2);
  border-radius: var(--border-radius);
}

.nav-content {
  z-index: 5;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 24px;
  gap: 16px;
}

.title-block {
  margin-right: auto;
  color: rgba(255, 255, 255, 0.86);

  .title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 3px;
    line-height: 1.2;
  }

  .sub-title {
    margin: 2px 0 0;
    font-size: 12px;
    opacity: 0.9;
  }
}

.weather {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 14px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.action-icon {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
}

.control-panel {
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;

  .control-item {
    margin-bottom: 20px;
  }

  .control-label {
    margin-bottom: 8px;
    font-size: 13px;
    color: rgba(183, 223, 255, 0.95);
    letter-spacing: 0.5px;
  }

  .control-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;

    :deep(.ant-input-number) {
      width: 120px;
      background: rgba(33, 85, 156, 0.18);
      border-color: rgba(115, 186, 255, 0.35);
      box-shadow: inset 0 0 0 1px rgba(71, 156, 255, 0.16);
    }

    :deep(.ant-input-number-input) {
      color: #d8edff;
      background: transparent;
    }

    :deep(.ant-input-number-handler-wrap) {
      background: rgba(18, 53, 103, 0.32);
    }

    :deep(.ant-slider) {
      flex: 1;
      margin: 0;
    }

    :deep(.ant-slider-rail) {
      background: rgba(91, 154, 255, 0.24);
    }

    :deep(.ant-slider-track) {
      background: linear-gradient(90deg, #2d75ff 0%, #4ed0ff 100%);
      box-shadow: 0 0 10px rgba(60, 148, 255, 0.38);
    }

    :deep(.ant-slider-handle) {
      border-color: #7bc3ff;
      background: #d7ecff;
      box-shadow: 0 0 0 2px rgba(79, 141, 255, 0.24), 0 0 10px rgba(84, 184, 255, 0.55);
    }
  }

  .control-key {
    width: 56px;
    color: rgba(168, 212, 255, 0.86);
    font-size: 12px;
  }

  .color-picker {
    width: 40px;
    height: 24px;
    padding: 0;
    border: 1px solid rgba(90, 166, 255, 0.45);
    border-radius: 4px;
    background: transparent;
    cursor: pointer;
  }

  .color-value {
    color: rgba(194, 227, 255, 0.9);
    font-size: 12px;
    min-width: 64px;
    letter-spacing: 0.3px;
  }

  .control-actions {
    display: flex;
    gap: 10px;

    :deep(.ant-btn) {
      border-color: rgba(90, 166, 255, 0.45);
      color: #d9edff;
      background: linear-gradient(180deg, rgba(25, 76, 143, 0.45) 0%, rgba(17, 52, 102, 0.42) 100%);
      box-shadow: inset 0 1px 0 rgba(175, 220, 255, 0.2);
    }

    :deep(.ant-btn:hover),
    :deep(.ant-btn:focus) {
      border-color: rgba(111, 190, 255, 0.72);
      color: #ecf7ff;
      background: linear-gradient(180deg, rgba(34, 96, 178, 0.66) 0%, rgba(21, 66, 128, 0.62) 100%);
    }
  }
}
</style>

<style lang="less">
.header-nav-drawer .ant-drawer-content {
  background: radial-gradient(120% 90% at 100% 0%, rgba(48, 130, 255, 0.18) 0%, rgba(48, 130, 255, 0) 60%),
    linear-gradient(180deg, rgba(4, 10, 24, 0.98) 0%, rgba(3, 8, 20, 0.98) 100%);
  color: #e9f3ff;
}

.header-nav-drawer .ant-drawer-header {
  background: linear-gradient(90deg, rgba(10, 28, 58, 0.96) 0%, rgba(7, 21, 46, 0.92) 100%);
  border-bottom: 1px solid rgba(116, 185, 255, 0.28);
  box-shadow: inset 0 -1px 0 rgba(85, 165, 255, 0.24);
}

.header-nav-drawer .ant-drawer-title,
.header-nav-drawer .ant-drawer-close {
  color: #d8ecff;
  text-shadow: 0 0 10px rgba(71, 156, 255, 0.35);
}

.header-nav-drawer .ant-drawer-body {
  background: transparent;
}

.header-nav-drawer .ant-switch {
  background-color: rgba(78, 131, 204, 0.5);
}

.header-nav-drawer .ant-switch-checked {
  background: linear-gradient(90deg, #2f7dff 0%, #44c4ff 100%);
  box-shadow: 0 0 10px rgba(79, 170, 255, 0.5);
}
</style>
